import courseWrapper from 'cccisd-laravel-assignment/dist/components/navigations/courseWrapper';
import moduleNavigation from 'cccisd-laravel-assignment/dist/components/navigations/withModules';
import ckdNavigation from '../../components/ckdNavigation';

const navigations = [ckdNavigation, moduleNavigation, courseWrapper];

export default navigations;
